class SerialTimeService {
  private isInit = false;

  // delta between BE provided and initial client time, ms
  private delta: number;

  /**
   * Initialize serial timer
   *
   * @param initialSerialTime serial time base supplied by BE, ms
   */
  init(initialSerialTime: number) {
    this.delta = initialSerialTime - Date.now();
    this.isInit = true;
  }

  /**
   * Return serial time, based on the server time, ms
   */
  get time() {
    if (!this.isInit) {
      throw new Error('SerialTimeService should be initialized with #init(initialTime) prior to use');
    }

    return Date.now() + this.delta;
  }
}

export const serialTimeService = new SerialTimeService();
